import { AxiosInstance } from 'axios';
import { PaginationParams } from '../../types/apiType';

class ImageService {
  constructor(private ApiClient: AxiosInstance) {}

  upload = async (params: {
    files: { url: string; filename: string; source?: string; book?: { id: string; ownerId: string }; folderId?: string; eventId?: string }[];
  }) => {
    const { data } = await this.ApiClient.post('/file/upload', params);
    return data;
  };

  list = async (params?: PaginationParams) => {
    const { data } = await this.ApiClient.get('/file', { params: params || {} });
    return data;
  };

  update = async (params: {
    files: { filename: string; note?: string; addFolderId?: string; removeFolderId?: string; archive_time?: string; addBookId?: string }[];
  }) => {
    const { data } = await this.ApiClient.put('/file', params);
    return data;
  };

  requestPreSignedUrl = async (filename: string, userId: string) => {
    const { data } = await this.ApiClient.get('/file/pre-signed', { params: { filename, userId } });
    return data;
  };

  createTransferId = async (params: { renew?: boolean }) => {
    const { data } = await this.ApiClient.post('/file/transfer', params);
    return data;
  };
  verifyTransferId = async (params: { userId: string; transferId: string }) => {
    const { data } = await this.ApiClient.get('/file/transfer/verify', { params });
    return data;
  };
  updateTransferId = async () => {
    const { data } = await this.ApiClient.put('/file/transfer');
    return data;
  };
}

export default ImageService;
